import { render, staticRenderFns } from "./AllowRegisterPage.vue?vue&type=template&id=280f7346&scoped=true"
import script from "./AllowRegisterPage.vue?vue&type=script&lang=js"
export * from "./AllowRegisterPage.vue?vue&type=script&lang=js"
import style0 from "./AllowRegisterPage.vue?vue&type=style&index=0&id=280f7346&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280f7346",
  null
  
)

export default component.exports